import React, { useState } from 'react'
import { Anchor, ChevronDown, ArrowRight } from 'lucide-react'
import { motion } from 'framer-motion'

const item = (delay) => ({
  initial:  { opacity: 0, y: 22 },
  animate:  { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
})

export default function Hero({ title, thumb, tagline, meta, onBook }) {
  const [loaded, setLoaded] = useState(false)

  return (
    <section className="sc-hero">
      <div className={`sc-hero__bg ${loaded ? 'sc-hero__bg--zoom' : ''}`}>
        {thumb
          ? <img src={thumb} alt={title} onLoad={() => setLoaded(true)} />
          : <div className="sc-hero__bg-fallback" />
        }
        <div className="sc-hero__overlay" />
      </div>

      <div className="sc-hero__content">
        <motion.div className="sc-hero__eyebrow" {...item(0.1)}>
          <Anchor size={12} strokeWidth={1.5} />
          Luxury Cruise · Le Journey Halong
        </motion.div>

        <motion.h1 className="ljn-display sc-hero__title" {...item(0.25)}>
          {title}
        </motion.h1>

        <motion.p className="sc-hero__tagline" {...item(0.38)}>
          {tagline}
        </motion.p>

        <motion.div className="sc-hero__meta" {...item(0.5)}>
          {meta.map(({ icon: Icon, label }) => (
            <div key={label} className="sc-hero__meta-item">
              <Icon size={13} strokeWidth={1.5} />
              <span>{label}</span>
            </div>
          ))}
        </motion.div>

        <motion.div {...item(0.62)}>
          <button className="ljn-btn-hero" type="button" onClick={onBook}>
            Book This Voyage <ArrowRight size={15} />
          </button>
        </motion.div>
      </div>

      <div className="sc-hero__scroll">
        <span className="ljn-label" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '9px' }}>Scroll</span>
        <ChevronDown size={14} style={{ color: 'rgba(255,255,255,0.85)' }} />
      </div>
    </section>
  )
}
